import { useCallback, useEffect, useState } from "react";
import { DynamicForm, useApiService, validators } from "@art/shared-ui";
import { FormService } from "@art/shared-ui";
import { Typography } from "@mui/material";


export default function ArtClientAddPage({ closeDialog: _closeDialog }: { closeDialog: () => void }) {
    const apiService = useApiService();
    const [formService, setFormService] = useState<FormService | null>(null);
    const [data, setData] = useState<any>(null);
    // const [, setLoading] = useState<boolean>(true);
    const [, setLoading] = useState<boolean>(false);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);



    // useEffect(() => {
    //     if (!apiCalled.current && !data) {
    //         apiCalled.current = true;
    //         invokeKeyGeneration();
    //     }
    // }, []);

    useEffect(() => {

        if (formService && data) {
            formService?.setFormData({
                config: data
            })
        }
    }, [formService, data]);

    const invokeKeyGeneration = async (data: any) => {
        setLoading(true);
        apiService.post("/client/configuration", data, { showErrorSnack: true }).then(({ data: { data: response } }) => {
            const responseMap = {
                "Client-ID": response.client_id,
                "Client-Secret": response.client_secret,
                // "Environment": response.environment.title,
                // "ProjectKey": response.project_key.project_key,
                "Org-Title": response.environment.tenant_name,
            };

            setData(responseMap)
            setLoading(false)
            setIsSubmitting(false)

        })
    }


    const formBuilder = useCallback(() => {

        return [
            {
                type: "row",
                children: [
                    {
                        type: 'col',
                        classNames: ['col-12'],
                        children: [
                            {
                                id: "title",
                                type: "text",
                                label: "Title *",
                                value: "",
                                dataQa: 'app-client-title',
                                validate: validators((value) => {
                                    if (!value || value.trim() === "") {
                                        return "Title name is required.";
                                    }
                                    if (value.startsWith(" ")) {
                                        return "Title cannot start with a space.";
                                    }
                                    const trimmedValue = value.trim();
                                    if (trimmedValue.length > 20) {
                                        return "Title cannot be longer than 20 characters.";
                                    }
                                    if (trimmedValue.length < 3) {
                                        return "Title must be at least 3 characters long.";
                                    }
                                    return null;
                                }),
                            }
                        ]
                    }
                ]
            },
            {
                type: "row",
                children: [
                    {
                        type: 'col',
                        classNames: ['col-12'],
                        children: [
                            {
                                id: "expiry",
                                type: "date",
                                label: "Expiry",
                                value: null,
                                dataQa: 'app-client-expiry',
                                validate: validators((value) => {
                                    if (!value) {
                                        return "Expiry date is required.";
                                    }
                                    const selectedDate = new Date(value);
                                    const today = new Date();
                                    today.setHours(0, 0, 0, 0);
                                    if (Number.isNaN(selectedDate.getTime()) || selectedDate < today) {
                                        return "Expiry date cannot be earlier than today.";
                                    }
                                    return null;
                                }),
                            }
                        ]
                    }
                ]
            },
            {
                type: 'row',
                classNames: [''],
                children: [
                    {
                        type: 'col',
                        classNames: ['col-auto'],
                        children: [
                            {
                                type: 'submit-button',
                                label: 'Generate'
                            }
                        ]
                    },
                    {
                        type: 'col',
                        classNames: ['col-auto'],
                        children: [
                            {
                                type: 'reset-button',
                                label: 'Reset'

                            }
                        ]
                    }
                ]
            },
        ];
    }, []);

    // if (loading) {
    //     return (
    //         <LinearProgress />
    //     )
    // }

    if (data != null) {
        return <ArtClientSuccess data={data} />
    }

    return (
        <>
        <div className="add-client-dialog">
            <Typography mb={2}>Please remember to store this client secret in a safe place. For security reasons, it cannot be recovered later.</Typography>

            <DynamicForm
                formBuilder={formBuilder}
                onInit={(service: FormService) => {
                    setFormService(service)
                }}
                onSubmit={async (data: any) => {
                    if (!isSubmitting) {
                        setIsSubmitting(true);
                        invokeKeyGeneration(data);
                    }
                }}
            />
            </div>
        </>
    );
}

function ArtClientSuccess({ data }: any) {
    // const apiService = useApiService();
    // const apiCalled = useRef(false);
    const [formService, setFormService] = useState<FormService | null>(null);
    // const [, setLoading] = useState<boolean>(true);


    // useEffect(() => {
    //     if (!apiCalled.current && !data) {
    //         apiCalled.current = true;
    //         invokeKeyGeneration();
    //     }
    // }, []);

    useEffect(() => {

        if (formService && data) {
            formService?.setFormData({
                config: data
            })
        }
    }, [formService, data]);

    // const invokeKeyGeneration = async () => {
    //     apiService.post("/client/configuration", {}).then(({ data: { data: response } }) => {
    //         const responseMap = {
    //             "Client-ID": response.client_id,
    //             "Client-Secret": response.client_secret,
    //             // "Environment": response.environment.title,
    //             // "ProjectKey": response.project_key.project_key,
    //             "Org-Title": response.environment.tenant_name,
    //         };

    //         setData(responseMap)
    //         setLoading(false)

    //     })
    // }


    const formBuilder = useCallback((data: any) => {

        return [

            {
                id: 'config',
                type: 'copy',
                reference: 'config_display',
                value: JSON.stringify(data?.config, null, 2)
            },

            {
                type: "row",
                children: [
                    {
                        type: 'col',
                        classNames: ['col-12'],
                        children: [
                            {
                                id: "title",
                                label: "Download",
                                type: "button",
                                dataQa: 'btn-download',
                                onClick: () => {

                                    const blob = new Blob([JSON.stringify(data?.config, null, 2)], { type: 'application/json' });
                                    const url = URL.createObjectURL(blob);
                                    const a = document.createElement('a');
                                    a.href = url;
                                    a.download = 'adk-services.json';
                                    a.click();
                                    URL.revokeObjectURL(url);
                                }
                            },
                        ]
                    }
                ]
            },
        ];
    }, []);

    // if (loading) {
    //     return (
    //         <LinearProgress />
    //     )
    // }

    return (
        <>
            <Typography mb={2}>Please remember to store this client secret in a safe place. For security reasons, it cannot be recovered later.</Typography>

            <DynamicForm
                formBuilder={formBuilder}
                onInit={(service: FormService) => {
                    setFormService(service)
                }}
                onSubmit={async () => {
                    // formService?.updateValue("config_display", "google")
                }}
            />
        </>
    );
}
